type Listener = (action: unknown) => void;

const listeners = new Map<string, Set<Listener>>();

export const actionEmitter = {
  emit(type: string, action: unknown): void {
    listeners.get(type)?.forEach((fn) => fn(action));
  },
  on(type: string, fn: Listener): () => void {
    if (!listeners.has(type)) listeners.set(type, new Set());
    listeners.get(type)!.add(fn);
    return () => listeners.get(type)?.delete(fn);
  },
};

// Redux middleware — plug into configureStore
export const actionEmitterMiddleware =
  () =>
  (next: (a: unknown) => unknown) =>
  (action: unknown): unknown => {
    const result = next(action);
    if (action && typeof action === 'object' && 'type' in action) {
      actionEmitter.emit((action as { type: string }).type, action);
    }
    return result;
  };
